/**
 * The owner-step warning an enroll answer can carry (epic #860 D9, A17).
 *
 * `POST /api/campaigns/{id}/enroll` and `/bulk-enroll` add
 * `warnings: [{code: "owner_step_will_skip", …}]` when the campaign (or one it
 * reaches) has an `assign_user` step that this caller's enrollments will skip:
 * only trigger-rooted enrollments, or ones started by an admin
 * (`contacts:override_owner`), may reassign a Contact Owner.
 *
 * Two surfaces show it — Contacts' bulk enroll and EnrollCampaignModal — so the
 * copy lives here once (the lib/calendarWarnings.js pattern). The skip depends
 * on who enrolled, so it applies to every contact this caller enrolled.
 */
export const OWNER_STEP_WILL_SKIP = 'owner_step_will_skip';

export function ownerStepSkipWarning(data) {
    const enrolled = Number(data?.enrolled) || 0;
    const warns = Array.isArray(data?.warnings) ? data.warnings : [];
    if (enrolled <= 0 || !warns.some((w) => w?.code === OWNER_STEP_WILL_SKIP)) return null;
    return `Owner-reassignment steps will be skipped for ${enrolled} contact${enrolled === 1 ? '' : 's'} — only an admin can enroll contacts into campaigns that reassign owners.`;
}

export default ownerStepSkipWarning;
